import { ICrudLocale } from '@app/i18n/interface';

/** “Collection forecast” texts (pay later, REQ-076..REQ-078). Same keys as `es.ts`. */
export const PENDING_COLLECTION_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  PENDING_COLLECTION: {
    LABEL: {
      SINGULAR: 'Collection forecast',
      PLURAL: 'Collection forecast',
    },
    LIST: {
      TITLE: 'Bookings pending payment',
      DESCRIPTION: 'Bookings made with “pay later” that have not been charged yet: how much is expected and by when.',
      NO_DATA: 'No bookings pending payment.',
      NO_DATA_FILTER: 'No bookings pending payment match these filters.',
    },
    SUMMARY: {
      FORECAST_TITLE: 'This is a forecast, not revenue',
      FORECAST_DESC: 'Confirmed bookings pending payment. Some may be cancelled or never paid; the amount has not been charged and does not add to sales.',
      FORECAST_BADGE: 'Forecast',
      TOTAL: 'Expected to collect',
      TOTAL_NOTE: 'Across every booking matching the filters, excluding cancellations in progress.',
      COUNT: 'Bookings to collect',
      COUNT_NOTE: 'Excluding cancellations in progress.',
      CANCELLING: 'Cancellations in progress',
      CANCELLING_NOTE: '{{amount}} that will not be collected: not included in the total.',
      FAILED_TITLE: 'Could not load the forecast',
      FAILED_DESC: 'The figures did not load, so we do not know how much is left to collect. Reload the page; if it persists, check the API.',
    },
    FILTER: {
      TITLE: 'Filter the forecast',
      SEARCH: 'Search',
      SEARCH_PLACEHOLDER: 'Reference, customer, email or hotel',
      DUE_FROM: 'Deadline from',
      DUE_TO: 'Deadline to',
      CHECK_IN_FROM: 'Check-in from',
      CHECK_IN_TO: 'Check-in to',
      DATE_PLACEHOLDER: 'dd/mm/yyyy',
      DATE_INVALID: 'Write the date as dd/mm/yyyy.',
      INCLUDE_CANCELLATIONS: 'Include cancellations in progress',
      APPLY: 'Apply filters',
      CLEAR: 'Clear',
      NOTE: 'Sorted by deadline, the nearest first. In red, those due in less than 24 hours.',
    },
    FIELD: {
      ORDER: 'Booking',
      NO_NUMBER: 'No number',
      CUSTOMER: 'Customer',
      NO_CUSTOMER: 'No customer',
      HOTELS: 'Hotel',
      DATES: 'Check-in – check-out',
      AMOUNT: 'Amount',
      CANCELLING: 'Cancellation in progress',
      DEADLINE: 'Deadline',
      HOTEL_TIME: 'hotel time',
      UTC: '{{date}} UTC',
      DUE_SOON: 'Due in less than 24 h',
      REMINDERS: 'Reminders',
      REMINDERS_SENT: '{{count}} of 2 sent',
    },
  },
};
